export default __webpack_public_path__ + "static/media/0004.30673390.jpg";